module.exports = __webpack_public_path__ + "static/media/helpdesk-icon.57074a55.png";